// =====================================================================
// Win/Loss Judge (§4)
// =====================================================================
// 仕様準拠: closing_river_v9_spec.md §4
//
// 判定順序 (最初に成立した条件を採用、勝利優先):
//   1. 勝利           : node_count == 1 and moves_used <= N
//   2. 手数超過敗北    : moves_used >= N and node_count > 1
//   3. 合成不能敗北    : remaining_edges == 0 and node_count > 1
//   4. 非連結敗北      : active graph が node_count > 1 で非連結
//
// 「最後の1ノード残り」 が非連結敗北扱いになる事故を勝利優先で防ぐ。
// =====================================================================
import { countComponents } from './boardState.js';
export function judge(state) {
    const nodeCount = state.nodes.size;
    const edgeCount = state.activeEdges.size;
    // 1. 勝利
    if (nodeCount === 1) {
        if (state.movesUsed <= state.turnLimit) {
            const finalValue = state.nodes.values().next().value.value;
            return { kind: 'win', movesUsed: state.movesUsed, finalValue };
        }
        // ノード1個でも手数超過 (= 不可能だが定義上のガード)
        // 仕様上 「moves_used <= N で勝利」 なので、moves > N で1ノードなら turn_limit 敗北扱い
        return {
            kind: 'loss_turn_limit',
            movesUsed: state.movesUsed,
            nodesRemaining: nodeCount,
        };
    }
    // 2. 手数超過敗北
    if (state.movesUsed >= state.turnLimit && nodeCount > 1) {
        return {
            kind: 'loss_turn_limit',
            movesUsed: state.movesUsed,
            nodesRemaining: nodeCount,
        };
    }
    // 3. 合成不能敗北
    if (edgeCount === 0 && nodeCount > 1) {
        return {
            kind: 'loss_no_edges',
            movesUsed: state.movesUsed,
            nodesRemaining: nodeCount,
        };
    }
    // 4. 非連結敗北
    // ※ ノード2個以上、辺は残っているが非連結 (一部の橋が消費されたケース)
    const components = countComponents(state);
    if (components > 1 && nodeCount > 1) {
        return {
            kind: 'loss_disconnected',
            movesUsed: state.movesUsed,
            componentsCount: components,
        };
    }
    return { kind: 'in_progress' };
}
/** §11 N+1手目チェック: 次の入力が受け付け可能か */
export function canAcceptInput(state) {
    const result = judge(state);
    return result.kind === 'in_progress';
}
/** 終了状態か */
export function isTerminal(result) {
    return result.kind !== 'in_progress';
}
/** 勝利状態か */
export function isWin(result) {
    return result.kind === 'win';
}
//# sourceMappingURL=judge.js.map